import {
  FiChevronLeft,
  FiChevronRight,
  FiChevronsLeft,
  FiChevronsRight,
} from "react-icons/fi";

export const CustomPagination = ({
  total,
  page,
  handleChange,
  dataPerPage,
  handleDataPerPage,
  PAGE_SIZES,
  lang = "EN",
}) => {
  const totalPages = Math.ceil(total / dataPerPage);

  const pageNumbers = [];
  pageNumbers.push(1);
  if (page > 2) pageNumbers.push("...");
  if (page !== 1 && page !== totalPages) pageNumbers.push(page);
  if (page < totalPages - 1) pageNumbers.push("...");
  if (totalPages > 1) pageNumbers.push(totalPages);

  const NavBtn = ({ onClick, disabled, children }) => (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`flex justify-center items-center p-2 rounded-lg transition-all font-roboto ${
        disabled
          ? "bg-gray/60 text-gray-400 cursor-not-allowed"
          : "bg-primary/10 text-primary hover:bg-primary hover:text-white"
      }`}
    >
      {children}
    </button>
  );

  return (
    <div className="flex flex-col md:flex-row justify-between items-center mt-4 mb-2 px-2 gap-3">
      <div className="flex items-center gap-3">
        <p className="font-roboto text-xs text-gray-400">
          {lang === "ES"
            ? `Mostrando ${(page - 1) * dataPerPage + 1} a ${Math.min(page * dataPerPage, total)} de ${total} entradas`
            : `Showing ${(page - 1) * dataPerPage + 1} to ${Math.min(page * dataPerPage, total)} of ${total} entries`}
        </p>
        {PAGE_SIZES && handleDataPerPage && (
          <select
            value={dataPerPage}
            onChange={handleDataPerPage}
            className="text-xs font-roboto border border-primary/20 rounded-lg px-2 py-1.5 bg-gray/40 text-primary focus:outline-none focus:ring-2 focus:ring-primary/20"
          >
            {PAGE_SIZES.map((size) => (
              <option key={size} value={size}>
                {size} {lang === "ES" ? "/ pág" : "/ page"}
              </option>
            ))}
          </select>
        )}
      </div>

      <ul className="flex flex-wrap items-center gap-1.5 justify-center">
        <li>
          <NavBtn onClick={() => handleChange("First", page)} disabled={page === 1}>
            <FiChevronsLeft size={16} />
          </NavBtn>
        </li>
        <li>
          <NavBtn onClick={() => handleChange("Previous", page)} disabled={page === 1}>
            <FiChevronLeft size={16} />
          </NavBtn>
        </li>

        {pageNumbers.map((pageNumber, index) => (
          <li key={index}>
            {pageNumber === "..." ? (
              <div className="flex items-center justify-center w-8 h-8 font-roboto text-gray-400 text-sm">
                ...
              </div>
            ) : (
              <button
                type="button"
                className={`w-8 h-8 flex items-center justify-center rounded-lg font-roboto text-sm font-semibold transition-all ${
                  page === pageNumber
                    ? "bg-primary text-white"
                    : "bg-gray/60 text-gray-600 hover:bg-primary/10 hover:text-primary"
                }`}
                onClick={() => handleChange("", pageNumber)}
              >
                {pageNumber}
              </button>
            )}
          </li>
        ))}

        <li>
          <NavBtn onClick={() => handleChange("Next", page)} disabled={page === totalPages}>
            <FiChevronRight size={16} />
          </NavBtn>
        </li>
        <li>
          <NavBtn onClick={() => handleChange("Last", page)} disabled={page === totalPages}>
            <FiChevronsRight size={16} />
          </NavBtn>
        </li>
      </ul>
    </div>
  );
};
